<template>
  <div class="panel panel-primary student-view__panel-personal-data">
    <div class="panel-body">
      <ul class="nav nav-tabs">
        <li class="tabulated-list active" role="presentation">
          <a data-toggle="tab" href="#personal-guarantor-data-student">
            Dados do garantidor
          </a>
        </li>
        <li class="tabulated-list" role="presentation">
          <a data-toggle="tab" href="#personal-guarantor-data-address">
            Endereço
          </a>
        </li>
        <li class="tabulated-list" role="presentation">
          <a data-toggle="tab" href="#personal-guarantor-data-financial">
            Dados Financeiros
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <section class="tab-pane fade in active" id="personal-guarantor-data-student">
          <personal-data
            v-if="guarantorData.id"
            :personal-data="guarantorData"
            :student="guarantorData"
            :options="options"
          />
        </section>
        <section class="tab-pane fade" id="personal-guarantor-data-address">
          <address-data
            :house-data="guarantorData"
            :house-data-city="guarantorData.city"
            :house-data-state="guarantorData.state"
          />
        </section>
        <section class="tab-pane fade" id="personal-guarantor-data-financial">
          <financial-data :financial-data="guarantorData" />
        </section>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .panel__row {
    flex-wrap: wrap;
  }
</style>
<script>
import FinancialData from 'pages/Parcelamento/StudentView/PaymentPlanData/FinancialData';
import PersonalData from 'pages/Parcelamento/StudentView/PaymentPlanData/PersonalData';
import AddressData from 'pages/Parcelamento/StudentView/PaymentPlanData/AddressData';

export default {
  components: {
    FinancialData, PersonalData, AddressData,
  },
  props: {
    guarantorData: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
